import { Component, EventListener, GondelBaseComponent } from '@gondel/core';

/**
 * accordion module implementation.
 * @author Srdan Turudic <srdan.turudic@emea.merkleinc.com>
 */

enum Selectors {
	Section = '.js-accordion__section',
}

enum States {
	Expanded = 'state-cms-accordion-section--expanded',
}

@Component('Accordion')
export class Accordion extends GondelBaseComponent {
	/**
	 * Toggle state expanded on accordion section
	 * @param event
	 */
	@EventListener('click', Selectors.Section)
	public _onHeadClicked(event: PointerEvent): void {
		const target: HTMLDivElement = event.target as HTMLDivElement;
		target.classList.toggle(States.Expanded);
	}
}
